<template>
  <div class="sticky-breadcrumb-wrapper">
    <div class="sticky-breadcrumb" :class="{'sidebar-open' : sidebarIsOpen}">
      <v-container fluid py-0>
        <slot></slot>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sticky-breadcrumb',
  computed: {
    sidebarIsOpen () {
      return this.$store.state.sidebar.sidebarOpen
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/sticky-breadcrumb.vue